import { gql } from '@apollo/client';

// TODO: Query eSpots as part of this query so they are not chained?
const GET_SMALL_SCREEN_NAV_CATEGORIES = gql`
  query SmallScreenNavCategoriesData($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      brand
      navigationSubCategories(hideCategory: false) {
        categoryId
        espotIdentifier
        hasSpecialNavInteraction
        name
        navigationSubCategories(displayTypes: ["regular", "clearance", "featured"], expandByDisplayTypes: ["regular"]) {
          categoryId
          displayType
          name
          url
          navigationSubCategories {
            categoryId
            name
            url
          }
        }
      }
    }
  }
`;

export default GET_SMALL_SCREEN_NAV_CATEGORIES;
